import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import clsx from "clsx";
import ContentField, { ContentFieldPropsType } from "../ContentField";
import ContentValue, { ContentValuePropsType } from "../ContentValue";
import { ReactNode } from "react";
interface LineContentValuePropsType extends GeneralPropsType, ContentValuePropsType, ContentFieldPropsType {
  field?: string | ReactNode;
  value?: ReactNode;
  filedClassName?: string;
  valueClassName?: string;
}
function LineContentValue({
  field,
  value,
  overrideValueFontsize,
  valueDescription,
  filedClassName,
  valueClassName,
  children,
  className
}: LineContentValuePropsType) {
  return <div className={clsx("flex items-center justify-between gap-2", styles.container, className)} data-sentry-component="LineContentValue" data-sentry-source-file="index.tsx">
            <ContentField className={filedClassName} data-sentry-element="ContentField" data-sentry-source-file="index.tsx">{field}</ContentField>
            <ContentValue className={clsx("text-right", valueClassName)} overrideValueFontsize={overrideValueFontsize} valueDescription={valueDescription} data-sentry-element="ContentValue" data-sentry-source-file="index.tsx">
                {value}
            </ContentValue>
        </div>;
}
export default LineContentValue;